import { dataHooks } from '../../../../../libs/dataHooks';

export const categoryTagListDataHooks = dataHooks<{
  category: { slug: string };
  showMoreBtn: {};
}>('category-list');
